import { track } from '@farmersdog/analytics';

const split_get_treatment = 'Split - get_treatment';

/**
 * Gets treatment data from split as well as some split meta data
 * and logs to segment.
 *
 * Deduplication and feature filtering are handled by ImpressionLogger
 * in the ab-testing package before this callback is invoked.
 *
 * @param impressionData - Tracking impression data provided by split factory
 */
export function logImpression(impressionData: SplitIO.ImpressionData) {
  track(split_get_treatment, impressionData);
}
